import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSizeClass } from '../layout/sizeClass';
import { useT } from '../i18n';
import { getOverlayDepth } from './overlayStack';
import { installHotkeys, type CommandContext } from './useHotkeys';

/**
 * HotkeyHost — installiert den EINEN keydown-Dispatcher (docs/30 §9.3) genau
 * einmal fuer den ganzen App-Baum. Muss INNERHALB von <BrowserRouter> haengen,
 * weil getCtx useNavigate/useLocation liefert.
 *
 * getCtx wird bei JEDEM Tastendruck frisch aufgerufen (nicht gemerkt), liest
 * also immer die aktuellen Werte: navigate/pathname aus dem Router, sizeClass
 * aus der Groessenklasse, overlayDepth aus dem overlayStack. Deshalb reicht ein
 * einziger install-Effekt fuer die Lebensdauer der App; ein Wechsel von Route
 * oder Groessenklasse loest KEIN Re-Install aus (der Listener bleibt derselbe).
 */
export function HotkeyHost(): null {
  const navigate = useNavigate();
  const location = useLocation();
  const sizeClass = useSizeClass();
  const { t } = useT();

  // Refs waeren feiner, aber der ctx-Aufbau ist billig und getCtx liest die
  // Closures ohnehin erst beim Feuern. Wir binden getCtx an die aktuellen Werte
  // und re-installieren nur, wenn sich eine der Quellen aendert — der Listener
  // ist idempotent ab-/anzumelden (gleiche Referenz).
  useEffect(() => {
    const getCtx = (): CommandContext => ({
      sizeClass,
      pathname: location.pathname,
      hasDetail: false, // E4a: Liste|Detail-Kontext folgt in spaeteren Paketen.
      overlayDepth: getOverlayDepth(),
      navigate,
      t,
    });
    return installHotkeys(getCtx);
  }, [navigate, location.pathname, sizeClass, t]);

  return null;
}
